import React from 'react';
import ReactExport from 'react-export-excel';
import Button from '../../../../components/Button';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface PageTimingData {
  pageNo: number;
  averageTimeMs: number;
  totalResponses: number;
}

interface PageTimingDetailsTableProps {
  pageTimingData: PageTimingData[];
  formatTime: (ms: number) => string;
}

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const PageTimingDetailsTable: React.FC<PageTimingDetailsTableProps> = ({
  pageTimingData,
  formatTime,
}) => (
  <DashboardChartBox>
    <HeaderTitle>
      <p>Page Timing Details </p>
    </HeaderTitle>
    <div style={{ marginBottom: 16 }}>
      <ExcelFile
        element={
          <Button $marginRight="16px" $width="200px" $height="36px">
            Export all data to Excel
          </Button>
        }
        filename={`PageTimingDetails-${new Date().toISOString()}`}
      >
        <ExcelSheet data={pageTimingData} name="PageTimingDetails">
          <ExcelColumn
            label="Page Number"
            value={col => `Page ${col.pageNo}`}
          />
          <ExcelColumn label="Average Time (ms)" value="averageTimeMs" />
          <ExcelColumn label="Total Responses" value="totalResponses" />
        </ExcelSheet>
      </ExcelFile>
    </div>
    <h4 style={{ marginBottom: '16px' }}>Preview List: </h4>
    <table className="styled-table">
      <thead>
        <tr>
          <th>Page Number</th>
          <th>Average Time</th>
          <th>Total Responses</th>
        </tr>
      </thead>
      <tbody>
        {pageTimingData.map(item => (
          <tr key={item.pageNo}>
            <td>Page {item.pageNo}</td>
            <td>{formatTime(item.averageTimeMs ?? 0)}</td>
            <td>{item.totalResponses}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </DashboardChartBox>
);

export default PageTimingDetailsTable;
